export default __webpack_public_path__ + "static/media/pop.2c07a208.mp3";